import React, { useContext } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import GlobalContext from './GlobalContext'

export default function EnsureLogin ({ children }) {
  const { user } = useContext(GlobalContext)

  if (!user) {
    return <></>
  }
  if (user.isAuth) {
    return children || <Outlet />
  } else {
    return (
      <Navigate to='/admin/login' replace={true} />
    )
  }
}
